import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import DynamicMeta from './components/seo/DynamicMeta';
import SEOHead from './components/seo/SEOHead';
import { generateOrganizationSchema } from './utils/structuredData';
import AdminRoute from './components/auth/AdminRoute';

// Pages
import HomePage from './pages/HomePage';
import DatabasePage from './pages/DatabasePage';
import AnimatronicDetailPage from './pages/AnimatronicDetailPage';
import MapPage from './pages/MapPage';
import RankingGamePage from './pages/RankingGamePage';
import YetiEscapePage from './pages/games/YetiEscapePage';
import SongsPage from './pages/media/SongsPage';
import BlogPage from './pages/community/BlogPage';
import BlogPostPage from './pages/community/BlogPostPage';
import StorePage from './pages/community/StorePage';
import EvolutionPage from './pages/evolution/EvolutionPage';
import ForumPage from './pages/community/ForumPage';
import ForumTopicPage from './pages/community/ForumTopicPage';
import SubmitNewPage from './pages/community/SubmitNewPage';
import EditMediaPage from './pages/community/EditMediaPage';
import ContactPage from './pages/ContactPage';
import AboutUsPage from './pages/AboutUsPage';
import AdvertisingPage from './pages/AdvertisingPage';
import DirectoryPage from './pages/suppliers/DirectoryPage';
import NotFoundPage from './pages/NotFoundPage';
import ProfilePage from './pages/profile/ProfilePage';
import TrophiesPage from './pages/profile/TrophiesPage';
import AuthCallbackPage from './pages/auth/AuthCallbackPage';
import AdminPage from './pages/admin/AdminPage';

// Legal Pages
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';
import CookiePolicy from './pages/legal/CookiePolicy';
import Disclaimer from './pages/legal/Disclaimer';
import CopyrightPolicy from './pages/legal/CopyrightPolicy';

const App = () => {
  return (
    <>
      <SEOHead schema={generateOrganizationSchema()} />
      <DynamicMeta />
      
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="database" element={<DatabasePage />} />
          <Route path="database/:id" element={<AnimatronicDetailPage />} />
          <Route path="map" element={<MapPage />} />
          
          {/* Games & Media Routes */}
          <Route path="ranking-game" element={<RankingGamePage />} />
          <Route path="games/yeti-escape" element={<YetiEscapePage />} />
          <Route path="media/songs" element={<SongsPage />} />
          <Route path="evolution" element={<EvolutionPage />} />
          
          {/* Community Routes */}
          <Route path="community">
            <Route path="blog" element={<BlogPage />} />
            <Route path="blog/:slug" element={<BlogPostPage />} />
            <Route path="comments" element={<ForumPage />} />
            <Route path="comments/:id" element={<ForumTopicPage />} />
            <Route path="submit-new" element={<SubmitNewPage />} />
            <Route path="edit-media" element={<EditMediaPage />} />
            <Route path="store" element={<StorePage />} />
          </Route>
          
          <Route path="contact" element={<ContactPage />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="advertising" element={<AdvertisingPage />} />
          <Route path="suppliers/directory" element={<DirectoryPage />} />
          
          {/* Profile Routes */}
          <Route path="profile" element={<ProfilePage />} />
          <Route path="profile/trophies" element={<TrophiesPage />} />
          
          {/* Auth Routes */}
          <Route path="auth/callback" element={<AuthCallbackPage />} />
          
          {/* Admin Routes - Protected */}
          <Route path="admin" element={
            <AdminRoute>
              <AdminPage />
            </AdminRoute>
          } />
          
          {/* Legal Routes */}
          <Route path="legal/privacy" element={<PrivacyPolicy />} />
          <Route path="legal/terms" element={<TermsOfService />} />
          <Route path="legal/cookies" element={<CookiePolicy />} />
          <Route path="legal/disclaimer" element={<Disclaimer />} />
          <Route path="legal/copyright" element={<CopyrightPolicy />} />

          {/* 404 Route */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
};

export default App;